module.exports = __webpack_public_path__ + "static/img/design.0f004d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/design.jpg
// module id = 3ANy
// module chunks = 5